module.exports = __webpack_public_path__ + "static/media/GIF.81c73fc9.svg";